import * as React from 'react'
import { LoadingButton } from '@mui/lab/'

export default function ButtonLoading({
  children,
  href,
  startIcon,
  endIcon,
  onClick,
  fullWidth = true,
  size = 'medium',
  variant = 'contained',
  width,
  loading,
  sx = {},
  ...props
}) {
  const Root = href ? 'a' : 'button'
  return (
    <LoadingButton
      fullWidth={fullWidth}
      component={Root}
      href={href}
      variant={variant}
      size={size}
      startIcon={startIcon}
      endIcon={endIcon}
      onClick={onClick}
      loading={loading}
      sx={{
        textTransform: 'none',
        fontWeight: 'bold',
        width: width ? width : 'none',
        marginTop: '10px',
        ...sx,
      }}
      {...props}
    >
      {children}
    </LoadingButton>
  )
}
